import { render, staticRenderFns } from "./DiscoveryTableSorting.vue?vue&type=template&id=3411e992&scoped=true&"
import script from "./DiscoveryTableSorting.vue?vue&type=script&lang=js&"
export * from "./DiscoveryTableSorting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3411e992",
  null
  
)

export default component.exports